import { apiGet } from "../../utils"

export function getCatelogListAPI(data) {
    // const { sort = '' } = data || {}
    return apiGet(`/api/getCatelogListWeb`, data)
}

export function getCatelogByIdAPI(id) {
    return apiGet(`/api/getCatelogById?release_id=${id}`)
}